import { render, staticRenderFns } from "./Transfer_incorrect.vue?vue&type=template&id=9bc03dbe&scoped=true&"
import script from "./Transfer_incorrect.vue?vue&type=script&lang=js&"
export * from "./Transfer_incorrect.vue?vue&type=script&lang=js&"
import style0 from "./Transfer_incorrect.vue?vue&type=style&index=0&id=9bc03dbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc03dbe",
  null
  
)

export default component.exports